<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">      
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)" v-bind:disabled="desHabilitaEdicion">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} una categoría de puesto</option>
        <option v-for="TipoCategoriaPuesto in TiposCategoriasPuestos" :key="TipoCategoriaPuesto.TipoCategoriaPuestoId" :value="TipoCategoriaPuesto.TipoCategoriaPuestoId">{{TipoCategoriaPuesto.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'  

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        TiposCategoriasPuestos: [],
        idDelModelo: null,
        desHabilitaEdicion:true
      }
    },
    props: {
      prefijo: Number,      
      tipo: {
        Id: Number,
        Nombre: String
      },
      local: null,
      idDelInput: String,
      valorDefinido: Number,
      parametros: {},
      hereda:{
        type:Number,
        default:null
      }
    },
    created() {      
      this.desHabilitaEdicion = this.hereda != null && this.hereda == -1
      this.cargaCatalogoTiposCategoriasDePuestos(this.parametros)
    }, 
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;
      
      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_PJ_Catalogos_Establecer060TipoCategoriaPuesto", parametros);
    },
    methods: {
      cargaCatalogoTiposCategoriasDePuestos: function(parametrosDeConsulta) {
        let peticion = {          
          conInactivos: false,
          EsPrueba: this.enumeraciones.EsPrueba,
        }
        axios.post(api.conexion + api.PJ.catalogos.C060TiposCategoriasPuestos, peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.TiposCategoriasPuestos = respuesta.data.TiposCategoriasPuestos;                         
              return respuesta.data.TiposCategoriasPuestos;
            }
          }).catch(e => {
           console.log("No Hay Respuesta del Servidor" + e);
         });
      },
      cambiarDatos(evento) { 
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_PJ_Catalogos_Establecer060TipoCategoriaPuesto", parametros);
        this.$emit("valorParaElPadre", evento);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }      
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/060TiposCategoriasPuestos.vue